<div class="d-flex flex-fill">
  &nbsp;
  <div class="d-flex mr-4">
    <strong class="mr-1">Welcome, </strong>
    <span class="badge badge-info">{{ username_main }}</span>
  </div>
  <div class="d-flex">
    <strong class="mr-1">Warehouse: </strong>
  </div>
  <div class="d-flex">
    <span class="badge badge-primary">{{warehouse_location}}</span>
  </div>
</div>
<div class="d-flex toolbar-btn" (click)="toggleCart()">
  <span class="pl-2 pr-2"> Activities </span>
  <i class='d-flex justify-content-center align-self-center fas fa-box-open fa-lg pr-2'></i>
  <span class="d-flex justify-content-center align-content-center badge badge-primary m-auto">{{cartCount}}</span>
</div>